import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export async function confirmDiagnosis(
  treatment: Treatment,
  culture: Culture,
  id: string,
  config?: AxiosRequestConfig,
) {
  await companiesApi.put(
    apiRoutes.confirmDiagnosis(treatment, culture, id),
    undefined,
    config,
  )
}
